import { useEffect } from 'react';
import { initNativeShell } from '~/lib/native';

/**
 * Renders nothing — runs the one-time native chrome init (status bar + splash
 * hide) on mount. No-op on the web. Mounted once by the public layout when the
 * request is from the native app.
 */
export function NativeShell() {
  useEffect(() => {
    void initNativeShell();
  }, []);
  return null;
}
